export const typeHeader = [
  {
    id: 'name',
    label: '구분',
  },
  {
    id: 'type',
    label: '구분 종류',
  },
  {
    id: 'date',
    label: '최근 수정일',
  },
  {
    id: 'img',
    label: '마커 이미지',
  },
  {
    id: 'etc',
    label: '비고',
  },
  {
    id: 'edit',
    label: '수정',
  },
  {
    id: 'delete',
    label: '삭제',
  },
];

export const sportingHeader = [
  {
    id: 'name',
    label: '운동기구명',
  },
  {
    id: 'type',
    label: '분류',
  },
  {
    id: 'date',
    label: '등록일',
  },
  {
    id: 'register',
    label: '등록자',
  },
  {
    id: 'part',
    label: '소속',
  },
  {
    id: 'etc',
    label: '비고',
  },
  {
    id: 'edit',
    label: '수정',
  },
  {
    id: 'delete',
    label: '삭제',
  },
];

export const statusHeader = [
  {
    id: 'name',
    label: '상태명',
  },
  {
    id: 'date',
    label: '등록일',
  },
  {
    id: 'register',
    label: '등록자',
  },
  {
    id: 'part',
    label: '소속',
  },
  {
    id: 'etc',
    label: '비고',
  },
  {
    id: 'edit',
    label: '수정',
  },
  {
    id: 'delete',
    label: '삭제',
  },
];

export const departmentHeader = [
  {
    id: 'name',
    label: '부서명',
  },
  {
    id: 'date',
    label: '등록일',
  },
  {
    id: 'etc',
    label: '비고',
  },
  {
    id: 'edit',
    label: '수정',
  },
  {
    id: 'delete',
    label: '삭제',
  },
];
